/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
import { PHONE_NUMBERS } from '../constants/EarlyRequesterNames';
import { EN } from '../constants/Languages';
import { getPreferredLanguage } from '../utils/languageUtils';
export const fetchPhoneNumbers = countryOverride => {
  const preferredLanguage = getPreferredLanguage() || EN;
  let phoneNumbersUrl = '/monetization/v3/phone-numbers';
  phoneNumbersUrl = `${phoneNumbersUrl}/${preferredLanguage.toLowerCase()}`;
  if (countryOverride) {
    phoneNumbersUrl = `${phoneNumbersUrl}?preferredCountry=${countryOverride}`;
  }
  return http.get(phoneNumbersUrl);
};
export const getPhoneNumbers = () => {
  const earlyRequest = getEarlyRequesterResult(PHONE_NUMBERS);
  const earlyRequestWithFallback = earlyRequest ? earlyRequest.catch(() => fetchPhoneNumbers()) : fetchPhoneNumbers();
  return earlyRequestWithFallback;
};